import { type PopoverOrigin } from "@mui/material";

interface PositionProps {
  anchorOrigin: PopoverOrigin;
  transformOrigin: PopoverOrigin;
}

/**
 * Position menu directly with top edge touching top edge of anchor element, centered
 */
export const MENU_POS_ABOVE: PositionProps = {
  anchorOrigin: {
    vertical: "top",
    horizontal: "center",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "center",
  },
};

/**
 * Position menu directly below the anchor element, centered
 */
export const MENU_POS_BELOW: PositionProps = {
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "center",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "center",
  },
};

/**
 * Position menu directly below the anchor element, expanding to the left
 */
export const MENU_POS_LEFT: PositionProps = {
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "left",
  },
};

/**
 * Position menu directly below the anchor element, expanding to the right
 */
export const MENU_POS_RIGHT: PositionProps = {
  anchorOrigin: {
    horizontal: "right",
    vertical: "bottom",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "right",
  },
};
